<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-fill-black dark:tw-fill-white" viewBox="0 0 16 14"><path d="M1.51 14a1 1 0 0 1-.7-1.7L6.11 7 .8 1.71A1 1 0 1 1 2.22.3l6 6a1 1 0 0 1 0 1.42l-6 6a1 1 0 0 1-.7.3M9.51 14a1 1 0 0 1-.7-1.7l4.6-4.59a1 1 0 0 0 0-1.42l-4.6-4.58A1 1 0 1 1 10.22.3l4.6 4.6a3 3 0 0 1 0 4.23l-4.6 4.6a1 1 0 0 1-.7.28"/></svg>
</template>
